import ToasterComponent from "shared/components/Toaster";
import Routes from "./Routes";

// CSS — order matches pre-split App.js + physical order inside former landing.css
import "bootstrap/dist/css/bootstrap.min.css";
import "./Assets/css/404_error.css";
import "./Assets/css/common.css";
import "./Assets/css/custom.css";
import "./Assets/css/delete_account_info.css";
import "./Assets/css/home.css";
import "./Assets/css/landing.css";
import "./Assets/css/download_app.css";
import "./Assets/css/landing_page.css";
import "./Assets/css/navbar.css";
import "./Assets/css/pricing_page.css";
import "./Assets/css/about_us_page.css";
import "./Assets/css/contact_us.css";
import "./Assets/css/products_page.css";
import "./Assets/css/products_download_api_section.css";
import "./Assets/css/news_page.css";
import "./Assets/css/privacy.css";
import "./Assets/css/terms_and_condition.css";

function App() {
  return (
    <>
      <Routes />
      <ToasterComponent />
    </>
  );
}

export default App;
